var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-download"},[_c('div',{staticClass:"corpo"},[_c('div',{staticClass:"titulo-download negrito"},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('div',{staticClass:"subtitulo-download"},[_vm._t("subtitulo")],2),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }